import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import "./provide-email-password-stylesheet.scss";
import {
  MdsTextInput,
  MdsTextInputSecure,
  MdsLink,
  MdsButton,
  MdsBanner,
  MdsCheckbox,
} from "@mds/react";
// @ts-ignore
import TransmitService from "../../../../script/autheJs/uiHandler/service.js";
import {
  getAutheEndpoint,
  getErrorPageEndpoint,
  getRegistrationEndpoint,
  // @ts-ignore
} from "../../../../utils/getEndpoints.js";
// @ts-ignore
import error_messages from "../../../../script/error-messages.js";
import {
  getRealm,
  getAppId,
  getResumeURL,
  // @ts-ignore
} from "../../../../script/main.js";
import MobileIllustration from "../assets/mobile-illustration.svg";
import { isEmpty } from "./index";

interface LoginFormType {
  username: string;
  password: string;
}

const ProvideEmailPswd = () => {
  const [showCredentialError, setShowCredentialError] = useState("");
  const [isEmptyUsernameError, setIsEmptyUsernameError] = useState(false);
  const [isEmptyPasswordError, setIsEmptyPasswordError] = useState(false);

  const transmitService = new TransmitService("login"); // needs to be replaced

  const urlParams = new URLSearchParams(window.location.search);
  const paramToken = urlParams.get("params");
  let payload = {} as any;
  let isDeveloperPortal;

  try {
    payload = JSON.parse(atob(paramToken!.split(".")[1]));
    isDeveloperPortal = payload.extras.brand === "DEVELOPER-PORTAL";
  } catch (error) {
    console.error("Error parsing token: ", error);
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<{ loginData: LoginFormType }>();

  const onSubmit = handleSubmit((data, event?) => {
    event?.preventDefault();
    let payload = {} as any;
    resetErrorState();
    event?.preventDefault();
    const { username, password } = data.loginData;
    if (isEmpty(username) || isEmpty(password)) {
      setIsEmptyUsernameError(isEmpty(username));
      setIsEmptyPasswordError(isEmpty(password));
    } else {
      const urlParams = new URLSearchParams(window.location.search);
      const paramToken = urlParams.get("params");
      payload = JSON.parse(atob(paramToken!.split(".")[1]));
      handleLoginAttempt(data.loginData, payload, false);
    }
  });

  const handleLoginAttempt = async (
    loginData: LoginFormType,
    payload: any,
    isSSO?: boolean
  ) => {
    const { username, password } = loginData;
    const policyId = "password_and_otp_auth";
    let policyParams = {
      aud: payload.extras.aud,
      acr_values: payload.extras.acr_values,
      ids: isSSO ? "ida" : 1,
    };

    const appID = getAppId();
    const clientContext = { username: username, password };
    try {
      const successfulAuth = await transmitService.startAuth(
        username,
        policyId,
        policyParams,
        clientContext
      );
      // POST back to Ping Federate
      document
        .getElementById("ping1")!
        .setAttribute("action", getResumeURL(payload));
      document
        .getElementById("ts1")
        ?.setAttribute("value", successfulAuth.getToken());

      document.getElementById("ts2")?.setAttribute("value", username);
      document.getElementById("ts3")?.setAttribute("value", appID);
      document
        .getElementById("ts4")
        ?.setAttribute("name", payload.extras.realmParam);
      document.getElementById("ts4")?.setAttribute("value", payload.realm);
      document.getElementById("ts5")?.setAttribute("value", "submit");
      transmitService.doLogout();
      (document.getElementById("ping1") as HTMLFormElement).submit();
    } catch (err: any) {
      console.error(`TS journey - ${policyId}  execution failed : \n ` + err);
      const errorCode = err.getErrorCode();
      const loginAuthErrorData = err.getData();
      if (errorCode === 1) {
        let errorKey =
          loginAuthErrorData?.additional_data?.errors[0]?.code.replace(
            "PASSWORD",
            "PSWD"
          );
        setShowCredentialError(error_messages[errorKey]); // problem line
      } else if (errorCode === 5) {
        setShowCredentialError(error_messages.PWD_CORRECT_BUT_EXPIRED);
      } else if (
        errorCode == 9 &&
        err._data.failure_data.reason.type == "locked"
      ) {
        setShowCredentialError(error_messages.PSWD_LOCKED);
      } else {
        setShowCredentialError(err.getMessage());
      }
    }
  };

  const doInitTransmit = async () => {
    const endpoint = getAutheEndpoint();
    const realm = getRealm();
    const appId = getAppId();
    try {
      await transmitService.startInit(endpoint, realm, appId, "custom");
    } catch (err) {
      console.error("Transmit SDK Initialization failed: \n" + err);
      location.replace(getErrorPageEndpoint("login"));
    }
  };

  useEffect(() => {
    try {
      payload = JSON.parse(atob(paramToken!.split(".")[1]));
    } catch {
      location.replace(getErrorPageEndpoint("login"));
    }
    doInitTransmit();
  }, []);

  const resetErrorState = () => {
    setIsEmptyPasswordError(false);
    setIsEmptyUsernameError(false);
    setShowCredentialError("");
  };

  return (
    <>
      <div id="login-content">
        <div className="back-button-mobile-wrapper">
          <MdsButton
            text="Back"
            iconAccessibleDescription=""
            id="mb-ct-back-button"
            iconType="ico_chevron_left"
            iconPosition="leading"
            onClick={() => window.history.back()}
            variant="tertiary"
          />
        </div>
        <h2 id="sign-in-greeting">Sign in to the dashboard</h2>
        <p id="sign-in-p">
          Enter the email address associated with your Chase developer account
        </p>
        <form id="partner-portal-login-form" onSubmit={onSubmit}>
          {showCredentialError && (
            <MdsBanner
              variant="critical"
              background="themed"
              bannerMessage={showCredentialError}
              bannerTitle="Error"
              accessibleTextIcon="Informational Icon"
              heading-level="2"
              showCloseButton={false}
            />
          )}
          <div className="inputs">
            <MdsTextInput
              id={"input-username"}
              label={"Email ID"}
              errorMessage={
                isEmptyUsernameError ? "Enter email address" : undefined
              }
              variant="box"
              {...register("loginData.username")}
            />
            <MdsTextInputSecure
              id={"input-password"}
              label="Password"
              errorMessage={isEmptyPasswordError ? "Enter password" : undefined}
              variant="box"
              {...register("loginData.password")}
            />
          </div>
          <div className="remember-forgot-pw">
            <MdsCheckbox
              id="remember-me-check"
              label="Remember me"
              removeBottomMargin
            />
          </div>
          <MdsButton
            id="sign-in-button"
            text="Sign in"
            variant="primary"
            widthType="layout"
            type="submit"
          />
          <div className="buttons">
            <MdsButton
              text="Forgot password?"
              id="forgot-password-link"
              variant="tertiary"
              onClick={() =>
                window.location.replace(
                  `${
                    window.location.href.includes("localhost")
                      ? "/"
                      : "/apix_login/"
                  }forgot-password/index.html?params=${paramToken}`
                )
              }
            />
            <p className="sign-in-with-sso">
              <span>
                <MdsButton
                  variant="tertiary"
                  onClick={() =>
                    handleLoginAttempt(
                      { username: "wf", password: "" },
                      payload,
                      true
                    )
                  }
                  text="Use single sign-on (SSO) instead"
                />
              </span>
            </p>
          </div>
          <p className="need-an-account">
            Need an account?{"  "}
            <span>
              <MdsLink
                href={`${getRegistrationEndpoint()}`}
                text="Sign up"
                underline
              />
            </span>
          </p>
        </form>
      </div>
      <div id="img-parent">
        <img
          id="login-mobile-background-image"
          src={MobileIllustration}
          alt=""
        />
      </div>
    </>
  );
};

export default ProvideEmailPswd;
